import { useEffect, useRef } from 'react';
import { useMyCompanyUser } from '@/companies/hooks';
import { useUpdateCompanyUserAction } from '@/companies/actions';

export function useTimezoneAutoDetect(): void {
    const companyUser = useMyCompanyUser();
    const { updateCompanyUser } = useUpdateCompanyUserAction();
    const updateCompanyUserRef = useRef(updateCompanyUser);
    updateCompanyUserRef.current = updateCompanyUser;
    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current) return;
        if (!companyUser) return;
        if (!companyUser.timezoneAutoDetect) return;

        const browserTimezone =
            Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (companyUser.timezone === browserTimezone) return;

        hasRun.current = true;
        updateCompanyUserRef
            .current(companyUser.id, { timezone: browserTimezone })
            .catch(() => {
                // Silently fail - non-critical operation
            });
    }, [companyUser]);
}
